// noinspection JSXUnresolvedComponent
import { revocationValidationRules } from "./revocation.validation.rules";

import Header from "../../../../../layout/Header/Header";
import Breadcrumbs from "../../../../../common/Breadcrumbs/Breadcrumbs";
import Footer from "../../../../../layout/Footer/Footer";
import IC from "../../../../../common/compositions/InputComposition/IC";
import ModalBanOverlay from "../../../../../common/Modal/ModalBanOverlay/ModalBanOverlay";
import SimpleDropdown
    from "../../../../../common/compositions/InputComposition/dropdown.types/SimpleDropdown/SimpleDropdown";

import InputCompositionContext from "../../../../../../hooks/useInputCompositionContext/useInputCompositionContext";

import OkButton from "../../../../../common/Button/OKButton/OKButton";

import DelegationInProgressItem
    from "../../../../../common/compositions/InputComposition/dropdownItems.types/DelegationInProgressItem/DelegationInProgressItem";
import {
    clearErrorNotificationContentAction,
} from "../../../../../../redux/actions/MyDivision/Delegation/AuthorityDelegation/clearErrorNotificationContent.action";

import {
    getActiveRequestDelegations,
} from "../../../../../../redux/actions/MyDivision/RequestsDelegation/AuthorityRequestDelegation/thunk/getActiveDelegations.thunk.action";
import {
    clearActiveDelegations,
} from "../../../../../../redux/actions/MyDivision/Delegation/AuthorityDelegation/clearActiveDelegations.action";
import {
    editRequestDelegationThunkAction,
} from "../../../../../../redux/actions/MyDivision/RequestsDelegation/AuthorityRequestRevocation/thunk/editRequestDelegation.thunk.action";
import FrontendFormValidationService from "../../../../../../frontend.services/FrontendFormValidation.service";

import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import "./AuthorityRequestRevocation.scss";
import moment from "moment";

const AuthorityRequestRevocation = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();
    const requestsDelegations = useSelector(state => state.myDivision.requestsDelegations);


    const errorNotificationContent = useSelector(state => state.myDivision.errorNotificationContent);
    const [delegation, setDelegation] = useState(requestsDelegations && params?.id &&
    requestsDelegations.length && requestsDelegations.find(el => el.id === Number(params.id)) ?
        requestsDelegations.find(el => el.id === Number(params.id)) : null );
    const [revocationState, setRevocationState] = useState({
        rules: {
            "to": ["notEmpty"],
        },
    });
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [modalSuccess, setModalSuccess] = useState(false);
    const [notification, setNotification] = useState(false);

    const context = [revocationState, setRevocationState, isError, setIsError];

    function backButtonHandler() {
        navigate("/divisions/structure/request-delegation");
    }

    console.log(params);
    function submitHandler() {
        console.log(delegation);
        setRevocationState((prevState) => {
            return    {...prevState,
                id:params.id,
                from:prevState.from ? prevState.from :  delegation.from,
            };
        });
        const revokeDelegation = {
            ...revocationState,
            id:params.id,
            // from: delegation.from,
        };
        if (
            requestsDelegations &&
            requestsDelegations.length &&
            requestsDelegations.find((el) => el.id === Number(params.id)) &&
            requestsDelegations.find((el) => el.id === Number(params.id)).from &&
            isDateInRange(new Date(), new Date(requestsDelegations.find((el) => el.id === Number(params.id)).from))
        ) {
            revokeDelegation.rules =  {
                "to": ["notEmpty"],
                "from": ["notEmpty", "earlierThan"],
            }
            setRevocationState((prevState) => {
                return    {...prevState,
                    rules: {
                        ...prevState.rules,
                        "from": ["notEmpty", "earlierThan"],
                    },
                };
            });
            console.log("revocationState:  ",revocationState);
        } else {
            revokeDelegation.from = delegation.from;
            revokeDelegation.rules =  {
                "to": ["notEmpty"],
            };
        }
        console.log(revocationState);
        const validation = new FrontendFormValidationService(revocationState, isError, setIsError, revokeDelegation.rules);
        if (validation.validate()) {
            dispatch(editRequestDelegationThunkAction(
                revokeDelegation,
                setIsLoading,
                setModalSuccess,
                setNotification,
            ));
        }
    }

    function closeNotificationHandler() {
        dispatch(clearErrorNotificationContentAction());
        setNotification(false);
    }

    useEffect(() => {
        dispatch(clearActiveDelegations());
        dispatch(getActiveRequestDelegations({option: "initiator"}));
        return()=>{
            dispatch(clearActiveDelegations());
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function isDateInRange(date, startDate) {
        const startOfStartDate = new Date(startDate);
        startOfStartDate.setHours(0, 0, 0, 0);

        date.setHours(0, 0, 0, 0);



        return date < startOfStartDate ;
    }

    useEffect(() => {
        if(requestsDelegations?.length){
            setDelegation(requestsDelegations.find(el => el.id === Number(params.id)));
            setRevocationState((prevState) => {
                return    {...prevState,
                    id:params.id,
                    // from: delegation.from,

                };
            });

        }
    }, [requestsDelegations && requestsDelegations]);


    useEffect(() => {

    }, [errorNotificationContent]);
    console.log(delegation);
    console.log(requestsDelegations?.find(delegation => delegation.id === Number(params.id)).from);
    return (
        <>
            <Header />
            {/*<Breadcrumbs />*/}
            <main className={"revocation-transfer"}>
                <div className={"sub-header"}>
                    Изменение  делегирования

                </div>
                <div style={{ display: "flex" ,
                    flexDirection: "column" ,
                    gap: "15px",
                    background: "rgba(249, 249, 249, 1)",
                    width: "667px",
                    padding: "32px 40px",
                    borderRadius: "15px",
                    boxShadow: "rgba(249, 249, 249, 1) 0px 8px 24px",
                    color: "grey",
                }}>
                    {
                        delegation?.id ?
                            <>
                                <div> ФИО: {" "}
                                    { delegation.delegate.fullName}
                                </div>
                                <div> Типы заявок: {" "}
                                    {
                                        delegation.applicationTypes &&
                                        delegation.applicationTypes.length > 0 ?
                                            delegation.applicationTypes.map((e, index) => {
                                                console.log(e);
                                                return (
                                                    <span key={e.id}>
                                                            { index !== (delegation.applicationTypes.length - 1) ? `${ e.name }, ` : `${ e.name  }` }
                                                    </span>
                                                )
                                            })
                                            : null
                                    }
                                </div>
                                <div>Дата:  c {moment(delegation.from).format("DD.MM.YYYY")}
                                    {delegation.to ?` по  ${moment(delegation.to).format("DD.MM.YYYY")}` : " " }
                                </div>
                            </>
                        // requestsDelegations &&
                        // requestsDelegations.length && requestsDelegations.find(el => el.id === Number(params.id)) ?
                        //     <div>
                        //         { requestsDelegations.find(el => el.id === params.id).delegate.fullName}
                        //     </div>
                            : null
                    }
                </div>
                <InputCompositionContext.Provider value={context}>

                    {/*<IC*/}
                    {/*    require*/}
                    {/*    field={"id"}>*/}
                    {/*    <IC.Label*/}
                    {/*        value={"Выбор делегирования"}*/}
                    {/*    />*/}
                    {/*    <IC.Input />*/}
                    {/*    <IC.Dropdown>*/}
                    {/*        <SimpleDropdown*/}
                    {/*            delegation={true}*/}
                    {/*            items={*/}
                    {/*                requestsDelegations &&*/}
                    {/*                requestsDelegations.length*/}
                    {/*                    ? requestsDelegations*/}
                    {/*                    :*/}
                    {/*                    []*/}
                    {/*            }*/}
                    {/*        >*/}
                    {/*            <DelegationInProgressItem property={"delegate"} />*/}
                    {/*        </SimpleDropdown>*/}
                    {/*    </IC.Dropdown>*/}
                    {/*    <IC.Error />*/}
                    {/*</IC>*/}

                    <div style={{display:"flex", gap: "30px"}}>

                        { requestsDelegations &&
                            requestsDelegations.length &&
                            requestsDelegations.find((el) => el.id === Number(params.id)) &&
                            requestsDelegations.find((el) => el.id === Number(params.id)).from &&
                            isDateInRange(new Date(), new Date(requestsDelegations.find((el) => el.id === Number(params.id)).from))

                            ?


                            <IC field={"from"}
                                customStyle={"datepicker"}
                                require
                            >
                                <IC.Label value={"Дата начала делегирования"} />
                                <IC.DatepickerSelect
                                    minDate={new Date(moment().add(1, "days"))}
                                    maxDate={revocationState.to ? new Date(revocationState.to) : null}
                                />
                                {/*<IC.Error />*/}
                                <IC.Description value={`
* - поля обязательные для заполнения`} />
                            </IC> : null
                        }

                        <IC field={"to"}>
                            <IC.Label value={"Дата окончания делегирования"} />
                            <IC.DatepickerSelect
                                minDate={
                                !revocationState?.from ?
                                    requestsDelegations &&
                                    requestsDelegations.length &&
                                    revocationState.id &&
                                    requestsDelegations?.find(delegation => delegation.id === Number(params.id))?.from ?
                                        new Date(
                                            requestsDelegations?.find(delegation => delegation.id === Number(params.id)).from
                                        ).setHours(0,0,0,0) <= new Date().setHours(0,0,0,0) ?
                                            new Date(moment().add(1, "days")) :
                                            new Date(
                                                requestsDelegations?.find(delegation => delegation.id === Number(params.id)).from
                                            ) :new Date(moment().add(1, "days"))
                                    : new Date(revocationState.from)
                                }
                            />


                            {/*<IC.Error />*/}
                            <IC.Description
                                value={"Выберите дату, с которой делегирование будет прекращено"}/>

                        </IC>
                    </div>

                    {/*<div style={{ display: "flex", gap: "30px" }}>*/}



                    {/*    <IC*/}
                    {/*        field={"to"}>*/}
                    {/*        <IC.Label value={"Дата прекращения делегирование"} />*/}
                    {/*        /!*TODO PERIOD HIGHLIGHT*!/*/}
                    {/*        <IC.DatepickerSelect*/}

                    {/*            minDate={*/}
                    {/*                requestsDelegations && revocationState.id &&*/}
                    {/*                requestsDelegations.find(delegation => delegation.id === revocationState.id) &&*/}
                    {/*                new Date(*/}
                    {/*                    requestsDelegations.find(delegation => delegation.id === revocationState.id).from*/}
                    {/*                )*/}
                    {/*            }*/}
                    {/*            // maxDate={*/}
                    {/*            //     delegationsInProgress && revocationState.id &&*/}
                    {/*            //     delegationsInProgress.find(delegation => delegation.id === revocationState.id) &&*/}
                    {/*            //     new Date(*/}
                    {/*            //    moment(delegationsInProgress.*/}
                    {/*            //    find(delegation => delegation.id === revocationState.id).to) .add(12,"months")*/}
                    {/*            //     )*/}
                    {/*            // }*/}
                    {/*            checkbox={false} />*/}
                    {/*        <IC.Error />*/}
                    {/*    </IC>*/}

                    {/*</div>*/}

                    {/*<IC field={"comment"}>*/}
                    {/*    <IC.Label value={"Комментарий"} />*/}
                    {/*    <IC.Input />*/}
                    {/*    <IC.Description value={"* - поля обязательные для заполнения"} />*/}
                    {/*</IC>*/}

                </InputCompositionContext.Provider>


                <div style={{ width: "1160px", margin: "60px auto", display: "flex", justifyContent: "space-between" }}>
                    <OkButton
                        title={"назад"}
                        handler={backButtonHandler}
                    />
                    <OkButton
                        onValidation={isLoading}
                        // title={"изменить дату"}
                        title={"сохранить"}

                        handler={submitHandler}
                    />
                </div>

                {
                    notification &&
          errorNotificationContent &&
          errorNotificationContent.length
                        ? <div className={"delegation-transfer__notification"}>
                            <div onClick={closeNotificationHandler}
                                className={"delegation-transfer__notification__cross"}></div>
                            {
                                errorNotificationContent &&
                Array.isArray(errorNotificationContent)
                                    ? errorNotificationContent.map((e, i) => {
                                        return (<div key={i}><p>{e}</p> <br /></div>);
                                    })
                                    : <div>{errorNotificationContent}</div>}
                        </div>
                        : null
                }
            </main>
            <Footer />

            <ModalBanOverlay shown={modalSuccess}>
                <div className={"delegation-modal-status"}>
                    <div style={{ textAlign: "center" }} className={"delegation-modal-status__header sub-header"}>
                                Делегирование успешно изменено
                    </div>
                    <div className={"delegation-modal-status__buttons"}>
                        <OkButton title={"хорошо"} handler={backButtonHandler} />
                    </div>
                </div>
            </ModalBanOverlay>
        </>
    );
};

export default AuthorityRequestRevocation;
